import axios from "axios";

/**
 * FileService
 *
 * Service used to construct and export/download files and reports
 *
 *
 */

import pdfMake from "pdfmake/build/pdfmake.min.js";
import vfs_fonts from "pdfmake/build/vfs_fonts.js";
import fs from "@/services/FormatService";
import moment from "moment";
pdfMake.vfs = vfs_fonts.pdfMake.vfs;

export default {
	// completionReportPDF(project, user, pcr) {
	// 	var docDefinition = {
	// 		pageOrientation: "landscape",
	// 		info: {
	// 			title: "Completion Report"
	// 		},
	// 		styles: {
	// 			all: {
	// 				fontSize: 10
	// 			},
	// 			datacol: {
	// 				alignment: "right"
	// 			}
	// 		},
	// 		content: [
	// 			{
	// 				text:
	// 					"Completion Report (" +
	// 					user.client.name +
	// 					")            Generated: " +
	// 					moment().format("dddd, MMMM Do YYYY, h:mm:ss a"),
	// 				bold: true,
	// 				style: "all"
	// 			},
	// 			{
	// 				layout: "lightHorizontalLines", // optional
	// 				style: "all",
	// 				table: {
	// 					// headers are automatically repeated if the table spans over multiple pages
	// 					// you can declare how many rows should be treated as headers
	// 					headerRows: 2,
	// 					widths: [
	// 						"*",
	// 						"*",
	// 						"auto",
	// 						"auto",
	// 						"auto",
	// 						"auto",
	// 						"auto",
	// 						"auto",
	// 						"auto",
	// 						"auto",
	// 						"auto",
	// 						"auto",
	// 						"auto"
	// 					],

	// 					body: [
	// 						[
	// 							"",
	// 							"",
	// 							"Total",
	// 							"Unscored",
	// 							"Withheld",
	// 							"Review",
	// 							"Reliability",
	// 							"Resolution",
	// 							"Flagged",
	// 							"Flags Reviewed",
	// 							"Complete",
	// 							"Backread",
	// 							"Res. Reqd."
	// 						]
	// 					]
	// 				}
	// 			}
	// 		]
	// 	};
	// 	function datacol(text) {
	// 		return { text: text, style: "datacol" };
	// 	}
	// 	//Totals
	// 	var arr = [{ text: "Totals", bold: true }, ""];
	// 	arr.push(datacol(project.totals.total));
	// 	arr.push(datacol(project.totals.unscored));
	// 	arr.push(datacol(project.totals.withheld));
	// 	arr.push(datacol(project.totals.review));
	// 	arr.push(datacol(project.totals.reliability));
	// 	arr.push(datacol(project.totals.resolution));
	// 	arr.push(datacol(project.totals.flagged));
	// 	arr.push(
	// 		datacol(
	// 			project.totals.flagged_reviewed +
	// 				"(" +
	// 				pcr(
	// 					project.totals.flagged_reviewed,
	// 					project.totals.flagged
	// 				) +
	// 				"%)"
	// 		)
	// 	);
	// 	arr.push(
	// 		datacol(
	// 			project.totals.complete +
	// 				"(" +
	// 				pcr(project.totals.complete, project.totals.total) +
	// 				"%)"
	// 		)
	// 	);
	// 	arr.push(
	// 		datacol(
	// 			project.totals.backread +
	// 				"(" +
	// 				pcr(project.totals.backread, project.totals.complete) +
	// 				"%)"
	// 		)
	// 	);
	// 	arr.push(
	// 		datacol(
	// 			project.totals.resolution +
	// 				project.totals.resolution_complete +
	// 				"(" +
	// 				pcr(
	// 					project.totals.resolution +
	// 						project.totals.resolution_complete,
	// 					project.totals.resolution + project.totals.complete
	// 				) +
	// 				"%)"
	// 		)
	// 	);
	// 	docDefinition.content[1].table.body.push(arr);

	// 	_.each(project.sections, section => {
	// 		docDefinition.content[1].table.body.push([
	// 			{ text: section.name, color: "grey" },
	// 			"",
	// 			"",
	// 			"",
	// 			"",
	// 			"",
	// 			"",
	// 			"",
	// 			"",
	// 			"",
	// 			"",
	// 			"",
	// 			""
	// 		]);

	// 		_.each(section.items, item => {
	// 			var arr = [""];
	// 			arr.push(item.name);
	// 			arr.push(datacol(item.total));
	// 			arr.push(datacol(item.unscored));
	// 			arr.push(datacol(item.withheld));
	// 			arr.push(datacol(item.review));
	// 			arr.push(datacol(item.reliability));
	// 			arr.push(datacol(item.resolution));
	// 			arr.push(datacol(item.flagged));
	// 			arr.push(
	// 				datacol(
	// 					item.flagged_reviewed +
	// 						"(" +
	// 						pcr(item.flagged_reviewed, item.flagged) +
	// 						"%)"
	// 				)
	// 			);
	// 			arr.push(
	// 				datacol(
	// 					item.complete +
	// 						"(" +
	// 						pcr(item.complete, item.total) +
	// 						"%)"
	// 				)
	// 			);
	// 			arr.push(
	// 				datacol(
	// 					item.backread +
	// 						"(" +
	// 						pcr(item.backread, item.complete) +
	// 						"%)"
	// 				)
	// 			);
	// 			arr.push(
	// 				datacol(
	// 					item.resolution_complete +
	// 						item.resolution +
	// 						"(" +
	// 						pcr(
	// 							item.resolution_complete + item.resolution,
	// 							item.complete + item.resolution
	// 						) +
	// 						"%)"
	// 				)
	// 			);
	// 			docDefinition.content[1].table.body.push(arr);
	// 		});
	// 	});

	// 	this.exportPDF(docDefinition, "ComplRpt " + user.client.name);
	// },

	// completionReportCSV(project, user, pcr) {
	// 	var filenameFields = [
	// 		"ComplRpt",
	// 		user.client.name,
	// 		moment().format("M.D.YY-H.mm.ss")
	// 	];
	// 	var rows = [
	// 		[
	// 			"Section",
	// 			"Item",
	// 			"Total",
	// 			"Unscored",
	// 			"Withheld",
	// 			"Review",
	// 			"Reliability",
	// 			"Resolution",
	// 			"Flagged",
	// 			"Flags Reviewed",
	// 			"Flags Reviewed %",
	// 			"Complete",
	// 			"Complete %",
	// 			"Backread",
	// 			"Backread %",
	// 			"Resolution Required",
	// 			"Resolution Required %"
	// 		]
	// 	];

	// 	_.each(project.sections, section => {
	// 		_.each(section.items, item => {
	// 			var row = [];
	// 			row.push(section.name);
	// 			row.push(item.name);
	// 			row.push(item.total);
	// 			row.push(item.unscored);
	// 			row.push(item.flagged);
	// 			row.push(item.review);
	// 			row.push(item.reliability);
	// 			row.push(item.resolution);
	// 			row.push(item.flagged);
	// 			row.push(item.flagged_reviewed);
	// 			row.push(pcr(item.flagged_reviewed, item.flagged));
	// 			row.push(item.complete);
	// 			row.push(pcr(item.complete, item.total));
	// 			row.push(item.backread);
	// 			row.push(pcr(item.backread, item.complete));
	// 			row.push(item.resolution_complete + item.resolution);
	// 			row.push(
	// 				pcr(
	// 					item.resolution_complete + item.resolution,
	// 					item.complete + item.resolution
	// 				)
	// 			);

	// 			rows.push(row);
	// 		});
	// 	});

	// 	var totals = [];
	// 	totals.push("Totals");
	// 	totals.push("Totals");
	// 	totals.push(project.totals.total);
	// 	totals.push(project.totals.unscored);
	// 	totals.push(project.totals.flagged);
	// 	totals.push(project.totals.review);
	// 	totals.push(project.totals.reliability);
	// 	totals.push(project.totals.resolution);
	// 	totals.push(project.totals.flagged);
	// 	totals.push(project.totals.flagged_reviewed);
	// 	totals.push(
	// 		pcr(project.totals.flagged_reviewed, project.totals.flagged)
	// 	);
	// 	totals.push(project.totals.complete);
	// 	totals.push(pcr(project.totals.complete, project.totals.total));
	// 	totals.push(project.totals.backread);
	// 	totals.push(pcr(project.totals.backread, project.totals.complete));
	// 	totals.push(
	// 		project.totals.resolution + project.totals.resolution_complete
	// 	);
	// 	totals.push(
	// 		pcr(
	// 			project.totals.resolution + project.totals.resolution_complete,
	// 			project.totals.resolution + project.totals.complete
	// 		)
	// 	);

	// 	rows.push(totals);

	// 	this.exportCSV(rows, filenameFields);
	// },

	scorersReportPDF(vue) {
		var col1 = "";
		col1 += "Scorer Report (" + vue.user.client.name + ")\n";
		if (vue.selectedProject) {
			col1 += "Project :" + vue.selectedProject.name + "\n";
		}
		if (vue.selectedSection) {
			col1 += "Section:" + vue.selectedSection.name + "\n";
		}
		if (vue.selectedItem) {
			col1 += "Item     :" + vue.selectedItem.name + "\n";
		}
		if (vue.selectedTeam) {
			col1 += "Team   :" + vue.selectedTeam.name + "\n";
		}

		var col2 = "";
		col2 +=
			" Generated: " +
			moment().format("dddd, MMMM Do YYYY, h:mm:ss a") +
			"\n";
		if (vue.fromDate) {
			col2 +=
				" From  : " +
				moment(vue.fromDate)
					.startOf("day")
					.format("dddd, MMMM Do YYYY, h:mm:ss a") +
				"\n";
		}
		if (vue.toDate) {
			col2 +=
				" To       : " +
				moment(vue.toDate)
					.endOf("day")
					.format("dddd, MMMM Do YYYY, h:mm:ss a");
		}
		var columns = [];
		columns[0] = {
			width: "*",
			text: col1,
			bold: true
		};
		columns[1] = {
			width: "auto",
			text: col2,
			bold: true
		};

		var docDefinition = {
			pageOrientation: "landscape",
			info: {
				title: "Scorer Report"
			},
			styles: {
				all: {
					fontSize: 8
				},
				datacol: {
					alignment: "right"
				}
			},
			content: [
				{
					columns: columns
				},

				{
					layout: "lightHorizontalLines", // optional
					style: "all",
					table: {
						// headers are automatically repeated if the table spans over multiple pages
						// you can declare how many rows should be treated as headers
						headerRows: 2,
						widths: [
							"*",
							"*",
							"*",
							"*",
							"*",
							"*",
							"*",
							"*",
							"*",
							"*",
							"*",
							"*",
							"*",
							"*",
							"*"
						],

						body: [
							[
								"Scorer",
								"Score Time",
								"Avg. Score Time",
								"Rate",
								"Scores",
								"Resolutions",
								"Validity",
								"Calibration",
								"Flags",
								"Total",
								"Res. Required",
								"Res. Required %",
								"Res. Disagreed",
								"Res. Disagreed %"
							]
						]
					}
				}
			]
		};
		function datacol(text) {
			return { text: text, style: "datacol" };
		}
		//Totals
		var arr = [{ text: "Totals", bold: true }, ""];
		arr.push(datacol(fs.medDuration(vue.totalsRow.total_time)));
		arr.push(datacol(fs.medDuration(vue.totalsRow.avg_time)));
		arr.push(datacol(fs.fixed1d(3600 / vue.totalsRow.avg_time)));
		arr.push(datacol(vue.totalsRow.total));
		arr.push(datacol(vue.totalsRow.res_count));
		arr.push(datacol(vue.totalsRow.val_count));
		arr.push(datacol(vue.totalsRow.cal_count));
		arr.push(
			datacol(
				vue.totalsRow.flag_unscored_count +
				vue.totalsRow.flag_scored_count
			)
		);
		arr.push(datacol(vue.totalsRow.sum));
		arr.push(datacol(vue.totalsRow.res_required_total));
		arr.push(
			datacol(fs.fixedPercent1d(vue.totalsRow.res_required_percent))
		);
		arr.push(datacol(vue.totalsRow.res_changed));
		arr.push(datacol(fs.fixedPercent1d(vue.totalsRow.res_changed_percent)));

		docDefinition.content[1].table.body.push(arr);

		_.each(vue.scorerStats, stat => {
			var arr = [];
			arr.push(fs.scorerID(stat.user));
			arr.push(datacol(stat.total_system_time));
			arr.push(datacol(fs.medDuration(stat.total_time)));
			arr.push(datacol(fs.medDuration(stat.avg_time)));
			arr.push(datacol(fs.fixed1d(3600 / stat.avg_time)));
			arr.push(datacol(stat.total));
			arr.push(datacol(stat.res_count));
			arr.push(datacol(stat.val_count));
			arr.push(datacol(stat.cal_count));
			arr.push(
				datacol(stat.flag_unscored_count + stat.flag_scored_count)
			);
			arr.push(datacol(stat.sum));
			arr.push(datacol(stat.res_required_total));
			arr.push(datacol(fs.fixedPercent1d(stat.res_required_percent)));
			arr.push(datacol(stat.res_changed));
			arr.push(datacol(fs.fixedPercent1d(stat.res_changed_percent)));

			docDefinition.content[1].table.body.push(arr);
		});
		this.exportPDF(docDefinition, "ScorerRpt " + vue.user.client.name);
	},

	scorersReportCSV(vue) {
		var filenameFields = [
			"ScorerRpt",
			vue.user.client.name,
		];
		// if (vue.selectedSection && vue.selectedSection.name != "All") {
		// 	filenameFields.push(vue.selectedSection.name);
		// }
		// if (vue.selectedItem && vue.selectedItem.name != "All") {
		// 	filenameFields.push(vue.selectedItem.name);
		// }
		// if (vue.selectedTeam && vue.selectedTeam.name != "All") {
		// 	filenameFields.push(vue.selectedTeam.name);
		// }
		if (vue.fromDate) {
			filenameFields.push(
				"from_" + moment(vue.fromDate).format("M.D.YY")
			);
		}
		if (vue.toDate) {
			filenameFields.push("to_" + moment(vue.toDate).format("M.D.YY"));
		}
		filenameFields.push(moment().format("M.D.YY-H.mm.ss"));
		var header = [
			"First Name",
			"Last Name",
			"Scorer ID",
			"Score Time",
			"Avg. Score Time",
			"Rate per hour",
			"Scores",
			"Resolutions",
			"Validity",
			"Calibration",
			"Flags",
			"Total",
			"Res. Required",
			"Res. Required %",
			"Res. Disagreed",
			"Res. Disagreed %"
		];

		var rows = [header];

		_.each(vue.scorerStats, stat => {
			var row = [];
			row.push(stat.user.first_name);
			row.push(stat.user.last_name);
			row.push(fs.scorerID(stat.user));
			row.push(fs.medDuration(stat.total_time, ""));
			row.push(fs.medDuration(stat.avg_time, ""));
			row.push(fs.fixed1d(3600 / stat.avg_time, ""));
			row.push(stat.total);
			row.push(stat.res_count);
			row.push(stat.val_count);
			row.push(stat.cal_count);
			row.push(stat.flag_unscored_count + stat.flag_scored_count);
			row.push(stat.sum);
			row.push(stat.res_required_total);
			row.push(fs.fixedPercent1d(stat.res_required_percent, ""));
			row.push(stat.res_changed);
			row.push(fs.fixedPercent1d(stat.res_changed_percent, ""));

			rows.push(row);
		});

		var totals = [];
		totals.push("Totals");
		totals.push("");
		totals.push("");
		totals.push(fs.medDuration(vue.totalsRow.total_time, ""));
		totals.push(fs.medDuration(vue.totalsRow.avg_time, ""));
		totals.push(fs.fixed1d(3600 / vue.totalsRow.avg_time, ""));
		totals.push(vue.totalsRow.total);
		totals.push(vue.totalsRow.res_count);
		totals.push(vue.totalsRow.val_count);
		totals.push(vue.totalsRow.cal_count);
		totals.push(
			vue.totalsRow.flag_unscored_count + vue.totalsRow.flag_scored_count
		);
		totals.push(vue.totalsRow.sum);
		totals.push(vue.totalsRow.res_required_total);
		totals.push(fs.fixedPercent1d(vue.totalsRow.res_required_percent, ""));
		totals.push(vue.totalsRow.res_changed);
		totals.push(fs.fixedPercent1d(vue.totalsRow.res_changed_percent, ""));

		rows.push(totals);

		this.exportCSV(rows, filenameFields);
	},

	userAgreementReportPDF(vue, showTraits) {
		var stats = vue.reportStats;
		var totals = vue.reportTotals;
		var user = vue.user;
		var asmtName = vue.selectedAsmt.name;

		var docDefinition = {
			pageOrientation: "landscape",
			info: {
				title: "User Agreement Report"
			},
			styles: {
				all: {
					fontSize: 10
				},
				datacol: {
					alignment: "right"
				}
			},
			content: [
				{
					text:
						"User Agreement Report (" +
						user.client.name +
						"\nAssessment: " +
						asmtName +
						"\nGenerated: " +
						moment().format("dddd, MMMM Do YYYY, h:mm:ss a"),
					bold: true,
					style: "all"
				},
				{
					layout: "lightHorizontalLines", // optional
					style: "all",
					table: {
						// headers are automatically repeated if the table spans over multiple pages
						// you can declare how many rows should be treated as headers
						headerRows: 2,
						widths: [
							"*",
							"*",
							"auto",
							"auto",
							"auto",
							"auto",
							"auto",
							"auto"
						],

						body: [
							[
								"User",
								"Trait",
								"IRR (exact)",
								"IRR (exact/adjacent)",
								"Validity (exact)",
								"Validity (exact/adjacent)",
								"Resolution Required",
								"Resolution Disagreed"
							]
						]
					}
				}
			]
		};
		function datacol(text) {
			return { text: text, style: "datacol" };
		}
		//Totals
		var arr = [{ text: "Totals", bold: true }, ""];
		arr.push(datacol(fs.fixedPercent1d(totals.irr_exact_percent)));
		arr.push(datacol(fs.fixedPercent1d(totals.irr_exact_adj_percent)));
		arr.push(datacol(fs.fixedPercent1d(totals.val_exact_percent)));
		arr.push(datacol(fs.fixedPercent1d(totals.val_exact_adj_percent)));
		arr.push(datacol(fs.fixedPercent1d(totals.res_required_percent)));
		arr.push(datacol(fs.fixedPercent1d(totals.res_changed_percent)));
		docDefinition.content[1].table.body.push(arr);

		_.each(stats, stat => {
			var arr = [];
			arr.push(stat.scorer);
			arr.push("Overall");
			arr.push(datacol(fs.fixedPercent1d(stat.irr_exact_percent)));
			arr.push(datacol(fs.fixedPercent1d(stat.irr_exact_adj_percent)));
			arr.push(datacol(fs.fixedPercent1d(stat.val_exact_percent)));
			arr.push(datacol(fs.fixedPercent1d(stat.val_exact_adj_percent)));
			var res_required = fs.fixedPercent1d(stat.res_required_percent);
			res_required += ` (${stat.res_required} out of ${stat.res_total})`;
			arr.push(datacol(res_required));
			var res_changed = fs.fixedPercent1d(stat.res_changed_percent);
			res_changed += ` (${stat.res_changed} out of ${stat.res_total})`;
			arr.push(datacol(res_changed));
			docDefinition.content[1].table.body.push(arr);

			if (showTraits) {
				_.each(stat.traits, trait => {
					var arr = [""];
					arr.push(trait.trait_name);
					arr.push(
						datacol(fs.fixedPercent1d(trait.irr_exact_percent))
					);
					arr.push(
						datacol(fs.fixedPercent1d(trait.irr_exact_adj_percent))
					);
					arr.push(
						datacol(fs.fixedPercent1d(trait.val_exact_percent))
					);
					arr.push(
						datacol(fs.fixedPercent1d(trait.val_exact_adj_percent))
					);
					arr.push(datacol(""));
					arr.push(datacol(""));
					docDefinition.content[1].table.body.push(arr);
				});
			}
		});

		this.exportPDF(docDefinition, "UserAgrRpt " + user.client.name);
	},

	userAgreementReportCSV(vue, showTraits) {
		var stats = vue.reportStats;
		var totals = vue.reportTotals;
		var user = vue.user;
		var asmtName = vue.selectedAsmt.name;

		var filenameFields = [
			"UserAgrRpt",
			user.client.name,
			asmtName,
			moment().format("M.D.YY-H.mm.ss")
		];
		var rows = [
			[
				"User",
				"Trait",
				"IRR (exact)",
				"IRR (exact/adjacent",
				"Validity (exact)",
				"Validity (exact/adjacent)"
			]
		];

		_.each(stats, stat => {
			var row = [];
			row.push(stat.scorer);
			row.push("Overall");
			row.push(fs.fixedPercent1d(stat.irr_exact_percent));
			row.push(fs.fixedPercent1d(stat.irr_exact_adj_percent));
			var val_exact =
				stat.val_total > 0
					? fs.fixedPercent1d(stat.val_exact_percent)
					: "";
			row.push(val_exact);
			var val_exact_adj =
				stat.val_total > 0
					? fs.fixedPercent1d(stat.val_exact_adj_percent)
					: "";
			row.push(val_exact_adj);
			row.push(fs.fixedPercent1d(stat.res_required_percent));
			row.push(fs.fixedPercent1d(stat.res_changed_percent));

			rows.push(row);

			if (showTraits) {
				_.each(stat.traits, trait => {
					var traitRow = [];
					traitRow.push(stat.scorer);
					traitRow.push(trait.trait_name);
					traitRow.push(fs.fixedPercent1d(trait.irr_exact_percent));
					traitRow.push(
						fs.fixedPercent1d(trait.irr_exact_adj_percent)
					);
					var val_exact =
						trait.val_total > 0
							? fs.fixedPercent1d(trait.val_exact_percent)
							: "";
					traitRow.push(val_exact);
					var val_exact_adj =
						trait.val_total > 0
							? fs.fixedPercent1d(trait.val_exact_adj_percent)
							: "";
					traitRow.push(val_exact_adj);
					traitRow.push("");
					traitRow.push("");

					rows.push(traitRow);
				});
			}
		});

		var totalRow = [];
		totalRow.push("Totals");
		totalRow.push("Totals");
		totalRow.push(fs.fixedPercent1d(totals.irr_exact_percent));
		totalRow.push(fs.fixedPercent1d(totals.irr_exact_adj_percent));
		var val_exact =
			totals.val_total > 0
				? fs.fixedPercent1d(totals.val_exact_percent)
				: "";
		totalRow.push(val_exact);
		var val_exact_adj =
			totals.val_total > 0
				? fs.fixedPercent1d(totals.val_exact_adj_percent)
				: "";
		totalRow.push(val_exact_adj);
		totalRow.push(fs.fixedPercent1d(totals.res_required_percent));
		totalRow.push(fs.fixedPercent1d(totals.res_changed_percent));

		rows.push(totalRow);

		this.exportCSV(rows, filenameFields);
	},

	projectAgreementReportPDF(vue, showTraits) {
		var stats = vue.reportStats;
		var totals = vue.reportTotals;
		var user = vue.user;
		var showVal = vue.showVal;
		var projectName = vue.selectedProject.name;

		var docDefinition = {
			pageOrientation: "landscape",
			info: {
				title: "Project Agreement Report"
			},
			styles: {
				all: {
					fontSize: 10
				},
				datacol: {
					alignment: "right"
				}
			},
			content: [
				{
					text:
						"Project Agreement Report (" +
						user.client.name +
						")\nProject: " +
						projectName +
						"\nGenerated: " +
						moment().format("dddd, MMMM Do YYYY, h:mm:ss a"),
					bold: true,
					style: "all"
				},
				{
					layout: "lightHorizontalLines", // optional
					style: "all",
					table: {
						// headers are automatically repeated if the table spans over multiple pages
						// you can declare how many rows should be treated as headers
						headerRows: 2,
						widths: ["*", "*", "*", "auto", "auto", "auto", "auto"],

						body: [
							[
								"Section",
								"Item",
								"Trait",
								"IRR (exact)",
								"IRR (exact/adjacent)",
								"Validity (exact)",
								"Validity (exact/adjacent)"
							]
						]
					}
				}
			]
		};
		function datacol(text) {
			return { text: text, style: "datacol" };
		}
		//Totals
		var arr = [{ text: "Totals", bold: true }, "", ""];
		arr.push(datacol(fs.fixedPercent1d(totals.irr_exact_percent)));
		arr.push(datacol(fs.fixedPercent1d(totals.irr_exact_adj_percent)));
		var val_exact = showVal
			? fs.fixedPercent1d(totals.val_exact_percent)
			: "——";
		arr.push(datacol(val_exact));
		var val_exact_adj = showVal
			? fs.fixedPercent1d(totals.val_exact_adj_percent)
			: "——";
		arr.push(datacol(val_exact_adj));
		docDefinition.content[1].table.body.push(arr);

		_.each(stats, stat => {
			var arr = [];
			arr.push(stat.section_name);
			arr.push(stat.item_name);
			arr.push("Overall");
			arr.push(datacol(fs.fixedPercent1d(stat.irr_exact_percent)));
			arr.push(datacol(fs.fixedPercent1d(stat.irr_exact_adj_percent)));
			var val_exact = showVal
				? fs.fixedPercent1d(stat.val_exact_percent)
				: "——";
			arr.push(datacol(val_exact));
			var val_exact_adj = showVal
				? fs.fixedPercent1d(stat.val_exact_adj_percent)
				: "——";
			arr.push(datacol(val_exact_adj));
			docDefinition.content[1].table.body.push(arr);

			if (showTraits) {
				_.each(stat.traits, trait => {
					var arr = ["", ""];
					arr.push(trait.trait_name);
					arr.push(
						datacol(fs.fixedPercent1d(trait.irr_exact_percent))
					);
					arr.push(
						datacol(fs.fixedPercent1d(trait.irr_exact_adj_percent))
					);
					var val_exact = showVal
						? fs.fixedPercent1d(trait.val_exact_percent)
						: "——";
					arr.push(datacol(val_exact));
					var val_exact_adj = showVal
						? fs.fixedPercent1d(trait.val_exact_adj_percent)
						: "——";
					arr.push(datacol(val_exact_adj));
					docDefinition.content[1].table.body.push(arr);
				});
			}
		});

		this.exportPDF(docDefinition, "ProjAgrRpt " + user.client.name);
	},

	projectAgreementReportCSV(vue, showTraits) {
		var stats = vue.reportStats;
		var totals = vue.reportTotals;
		var user = vue.user;
		var showVal = vue.showVal;
		var projectName = vue.selectedProject.name;

		var filenameFields = [
			"ProjAgrRpt",
			user.client.name,
			projectName,
			moment().format("M.D.YY-H.mm.ss")
		];
		var rows = [
			[
				"Section",
				"Item",
				"Trait",
				"IRR (exact)",
				"IRR (exact/adjacent",
				"Validity (exact)",
				"Validity (exact/adjacent)"
			]
		];

		_.each(stats, stat => {
			var row = [];
			row.push(stat.section_name);
			row.push(stat.item_name);
			row.push("Overall");
			row.push(fs.fixedPercent1d(stat.irr_exact_percent));
			row.push(fs.fixedPercent1d(stat.irr_exact_adj_percent));
			var val_exact = showVal
				? fs.fixedPercent1d(stat.val_exact_percent)
				: "";
			row.push(val_exact);
			var val_exact_adj = showVal
				? fs.fixedPercent1d(stat.val_exact_adj_percent)
				: "";
			row.push(val_exact_adj);

			rows.push(row);

			if (showTraits) {
				_.each(stat.traits, trait => {
					var traitRow = [];
					traitRow.push(stat.section_name);
					traitRow.push(stat.item_name);
					traitRow.push(trait.trait_name);
					traitRow.push(fs.fixedPercent1d(trait.irr_exact_percent));
					traitRow.push(
						fs.fixedPercent1d(trait.irr_exact_adj_percent)
					);
					var val_exact = showVal
						? fs.fixedPercent1d(trait.val_exact_percent)
						: "";
					traitRow.push(val_exact);
					var val_exact_adj = showVal
						? fs.fixedPercent1d(trait.val_exact_adj_percent)
						: "";
					traitRow.push(val_exact_adj);

					rows.push(traitRow);
				});
			}
		});

		var totalRow = [];
		totalRow.push("Totals");
		totalRow.push("Totals");
		totalRow.push("Totals");
		totalRow.push(fs.fixedPercent1d(totals.irr_exact_percent));
		totalRow.push(fs.fixedPercent1d(totals.irr_exact_adj_percent));
		var val_exact = showVal
			? fs.fixedPercent1d(totals.val_exact_percent)
			: "";
		totalRow.push(val_exact);
		var val_exact_adj = showVal
			? fs.fixedPercent1d(totals.val_exact_adj_percent)
			: "";
		totalRow.push(val_exact_adj);

		rows.push(totalRow);

		this.exportCSV(rows, filenameFields);
	},

	teamRosterCSV(vue, team) {
		let user = vue.user;

		let filenameFields = [
			team.name,
			"Roster",
			user.client.name,
			moment().format("M.D.YY-H.mm.ss")
		];

		let rows = [];
		rows.push([team.name]);
		rows.push([""]);
		rows.push([`Sections: (${team.sections.length})`]);
		_.each(team.sections, section => {
			rows.push([section.name]);
		});
		rows.push([""]);
		rows.push([`Users: (${team.users.length})`, "Scorer ID:", "Role:"]);
		_.each(team.users, user => {
			rows.push([
				user.user.full_name,
				user.user.scorer_id,
				user.role.name
			]);
		});

		this.exportCSV(rows, filenameFields);
	},

	projectManifestCSV(client, project) {
		let filenameFields = [
			client.name,
			project.name,
			"Manifest",
			moment().format("M.D.YY-H.mm.ss")
		];

		let rows = [
			[
				"Tenant Name",
				"Project Name",
				"Section Name",
				"Item Name",
				"Tenant Ref ID",
				"Section Ref ID",
				"Item Ref ID"
			]
		];
		_.each(project.sections, section => {
			_.each(section.items, item => {
				rows.push([
					client.name,
					project.name,
					section.name,
					item.name,
					client.ref_id,
					section.ref_id,
					item.ref_id
				]);
			});
		});

		this.exportCSV(rows, filenameFields);
	},

	exportPDF(doc, name) {
		pdfMake.createPdf(doc).download(name);
	},

	exportCSV(rows, filenameFields) {
		var processRow = function (row) {
			var finalVal = "";
			for (var j = 0; j < row.length; j++) {
				var innerValue = row[j] === null ? "" : row[j].toString();
				if (row[j] instanceof Date) {
					innerValue = row[j].toLocaleString();
				}
				var result = innerValue.replace(/"/g, '""'); //Escape single quotes
				if (result.search(/("|,|\n)/g) >= 0)
					//Escape other problematic characters
					result = '"' + result + '"';
				if (j > 0) finalVal += ",";
				finalVal += result;
			}
			return finalVal + "\n";
		};

		var processFileName = function (filenameFields) {
			var filename = "";
			for (var i = 0; i < filenameFields.length; i++) {
				var field = filenameFields[i];
				field = field.replace(/\s/g, "_"); //Replace white space with dashes
				field = field.replace(/<|>|\/|\\|:|"|\||\?|\*/g, "#"); //Replace forbidden characters with pound signs 'cause why not

				filename = filename + (i > 0 ? " " : "") + field;
			}

			return filename + ".csv";
		};

		//var csvFile = "sep=,\n";
		var csvFile = "";
		for (var i = 0; i < rows.length; i++) {
			csvFile += processRow(rows[i]);
		}

		var blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
		if (navigator.msSaveBlob) {
			// IE 10+
			navigator.msSaveBlob(blob, filename);
		} else {
			var link = document.createElement("a");
			if (link.download !== undefined) {
				// feature detection
				// Browsers that support HTML5 download attribute
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", processFileName(filenameFields));
				link.style.visibility = "hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	},

	CSVToArray(strData, strDelimiter) {
		// Check to see if the delimiter is defined. If not,
		// then default to comma.
		strDelimiter = strDelimiter || ",";
		// Create a regular expression to parse the CSV values.
		var objPattern = new RegExp(
			// Delimiters.
			"(\\" +
			strDelimiter +
			"|\\r?\\n|\\r|^)" +
			// Quoted fields.
			'(?:"([^"]*(?:""[^"]*)*)"|' +
			// Standard fields.
			'([^"\\' +
			strDelimiter +
			"\\r\\n]*))",
			"gi"
		);
		// Create an array to hold our data. Give the array
		// a default empty first row.
		var arrData = [[]];
		// Create an array to hold our individual pattern
		// matching groups.
		var arrMatches = null;
		// Keep looping over the regular expression matches
		// until we can no longer find a match.
		while ((arrMatches = objPattern.exec(strData))) {
			// Get the delimiter that was found.
			var strMatchedDelimiter = arrMatches[1];
			// Check to see if the given delimiter has a length
			// (is not the start of string) and if it matches
			// field delimiter. If id does not, then we know
			// that this delimiter is a row delimiter.
			if (
				strMatchedDelimiter.length &&
				strMatchedDelimiter != strDelimiter
			) {
				// Since we have reached a new row of data,
				// add an empty row to our data array.
				arrData.push([]);
			}
			// Now that we have our delimiter out of the way,
			// let's check to see which kind of value we
			// captured (quoted or unquoted).
			if (arrMatches[2]) {
				// We found a quoted value. When we capture
				// this value, unescape any double quotes.
				var strMatchedValue = arrMatches[2].replace(
					new RegExp('""', "g"),
					'"'
				);
			} else {
				// We found a non-quoted value.
				var strMatchedValue = arrMatches[3];
			}
			// Now that we have our value string, let's add
			// it to the data array.
			arrData[arrData.length - 1].push(strMatchedValue);
		}
		// Return the parsed data.
		return arrData;
	}
};



// WEBPACK FOOTER //
// ./src/services/FileService.js